import { Component, OnInit, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { VendorService } from '../../../services/vendor.service';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
	selector: 'app-vendordash-payments',
	templateUrl: './vendordash-payments.component.html',
	styleUrls: ['./vendordash-payments.component.scss'],
	animations: [
	  trigger('flipState', [
		  state('active', style({
			  transform: 'rotate3d(0, 1, 0, 179deg)',
		  })),
		  state('inactive', style({
			  transform: 'rotateY(0)'
		  })),
		  transition('active => inactive', animate('500ms ease-out')),
		  transition('inactive => active', animate('500ms ease-in')),
	  ]),
	]
})
export class VendordashPaymentsComponent implements OnInit {
	flip = 'inactive';
	@Output() viewData = new EventEmitter<any>();
	
	payments: any = [];
	viewing: any = false;
	title: any = '';

	constructor(private vendorService: VendorService) {}

	ngOnInit(): void {
		this.vendorService.getDashBoard().subscribe((results: any) => {
			if (results && results.payments) {
				this.payments = results.payments;
			}
		});
	}

	toggleFlip(data: any, title: string) {
		if (!data) {
			this.flip = 'inactive';
		} else {
			this.flip = (this.flip == 'active') ? 'inactive' : 'active';
		}

		if (this.flip == 'active') {
			this.viewing = data;
			this.title = title;
			const dashboard_data = { data: data, title: 'Payments' };
			this.viewData.emit(dashboard_data);
		} else {
			this.viewing = false;
			this.viewData.emit(false);
		}
	}

}
